export const PRODUCER_ZONE_URL_SEGMENT = 'strefa-producenta';

export const PAGE_LIMIT_ITEM = 36;
